import { Button } from '@mebi/ui'

export default function DownloadSection() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-neutral-900">Tải MeBi App</h2>
          <p className="text-lg text-neutral-600 mt-3">Chọn phiên bản phù hợp để bắt đầu sử dụng ngay.</p>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
            <Button size="lg" className="w-full bg-mebi-yellow-500 hover:bg-mebi-yellow-600 text-white font-semibold py-3">
              Tải cho Android
            </Button>
            <Button size="lg" variant="secondary" className="w-full font-semibold py-3">
              Mở Web App
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}